module.exports = __webpack_public_path__ + "img/model.8bc280b7.svg";